(() => {
  if (customElements.get('rg10000-comparison')) return;
  customElements.define('rg10000-comparison', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const signal = this.abort.signal;
      this.scroller = this.querySelector('.rg-compare-scroll');
      this.table = this.querySelector('table');
      this.sticky = this.querySelector('.rg-compare-sticky');
      this.track = this.querySelector('.rg-compare-sticky-track');
      this.refreshHeader();
      const update = () => this.positionHeader();
      const resize = () => { this.alignSummaries(); this.positionHeader(); };
      this.scroller.addEventListener('scroll', update, { signal, passive: true });
      if (this.closest('.rg-series-comparison')) {
        let gesture;
        let dragged = false;
        this.sticky.addEventListener('pointerdown', event => {
          dragged = false;
          if (!window.matchMedia('(max-width: 749px)').matches || event.button > 0) return;
          gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.scroller.scrollLeft };
        }, { signal });
        this.sticky.addEventListener('pointermove', event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          const dx = event.clientX - gesture.x;
          if (!dragged && (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(event.clientY - gesture.y))) return;
          dragged = true;
          this.sticky.setPointerCapture(event.pointerId);
          this.scroller.scrollLeft = gesture.left - dx;
          this.positionHeader();
        }, { signal });
        const finish = () => { gesture = null; };
        this.sticky.addEventListener('pointerup', finish, { signal });
        this.sticky.addEventListener('pointercancel', finish, { signal });
        this.sticky.addEventListener('wheel', event => {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          this.scroller.scrollLeft += event.deltaX;
          this.positionHeader();
        }, { signal, passive: false });
        this.sticky.addEventListener('click', event => {
          if (dragged) { event.preventDefault(); event.stopImmediatePropagation(); dragged = false; }
        }, { signal, capture: true });
      }
      window.addEventListener('scroll', update, { signal, passive: true });
      window.addEventListener('resize', resize, { signal });
      this.resize = new ResizeObserver(resize); this.resize.observe(this.table);
      this.addEventListener('click', event => {
        const stickyAdd = event.target.closest('.rg-compare-sticky-item [data-rg-compare-add]');
        if (stickyAdd) {
          const index = [...this.track.children].indexOf(stickyAdd.closest('.rg-compare-sticky-item'));
          this.table.querySelectorAll('thead th')[index]?.querySelector('[data-rg-compare-add]')?.click();
          return;
        }
        const swatch = event.target.closest('[data-rg-compare-color]');
        if (!swatch) return;
        const summary = swatch.closest('[data-rg-compare-summary]');
        summary.querySelectorAll('[data-rg-compare-color]').forEach(button => button.setAttribute('aria-pressed', String(button === swatch)));
        const variantInput = summary.querySelector('.rg-compare-add-form [name="id"]');
        const addButton = summary.querySelector('.rg-compare-add-form [data-rg-compare-add]');
        if (variantInput && swatch.dataset.rgVariantId) {
          variantInput.value = swatch.dataset.rgVariantId;
          variantInput.setAttribute('value', swatch.dataset.rgVariantId);
        }
        if (addButton) {
          addButton.disabled = swatch.dataset.rgAvailable !== 'true';
          addButton.removeAttribute('aria-disabled');
        }
        if (swatch.dataset.rgImage) {
          const image = summary.querySelector('img');
          if (image) { image.src = swatch.dataset.rgImage; image.removeAttribute('srcset'); image.parentElement.querySelectorAll('source').forEach(source => source.remove()); }
        }
        const decode = value => new DOMParser().parseFromString(value, 'text/html').body.textContent;
        const price = summary.querySelector('[data-rg-compare-price]');
        if (price && swatch.dataset.rgPrice) price.textContent = decode(swatch.dataset.rgPrice);
        const was = summary.querySelector('[data-rg-compare-was]');
        if (was) {
          if (swatch.dataset.rgCompare) { was.hidden = false; was.textContent = decode(swatch.dataset.rgCompare); }
          else { was.hidden = true; was.textContent = ''; }
        }
        const link = summary.querySelector('[data-rg-compare-link]');
        if (link && swatch.dataset.rgUrl) link.href = swatch.dataset.rgUrl;
        this.refreshHeader(); this.positionHeader();
      }, { signal });
      this.alignSummaries();
      this.positionHeader();
    }
    alignSummaries() {
      const summaries = [...this.querySelectorAll('[data-rg-compare-summary]')];
      for (const [selector, property] of [['.rg-compare-variants', '--rg-variant-height'], ['h3', '--rg-title-height']]) {
        this.style.removeProperty(property);
        const height = Math.ceil(Math.max(0, ...summaries.map(summary => summary.querySelector(selector)?.getBoundingClientRect().height || 0)));
        this.style.setProperty(property, `${height}px`);
      }
    }
    refreshHeader() {
      this.track.replaceChildren();
      this.table.querySelectorAll('thead th').forEach(cell => {
        const item = document.createElement('div'); item.className = 'rg-compare-sticky-item';
        const badge = cell.querySelector('.rg-compare-badge'); const heading = cell.querySelector('h3'); const link = cell.querySelector('.rg-compare-cta, .rg-compare-current');
        if (badge) item.append(badge.cloneNode(true));
        if (heading) item.append(heading.cloneNode(true));
        if (link) item.append(link.cloneNode(true));
        this.track.append(item);
      });
    }
    positionHeader() {
      const rect = this.scroller.getBoundingClientRect();
      const head = this.table.tHead.getBoundingClientRect();
      const header = document.querySelector('sticky-header');
      const headerRect = header?.getBoundingClientRect();
      const top = headerRect && headerRect.top <= 1 && headerRect.bottom > 0 ? headerRect.bottom : 0;
      this.sticky.hidden = false;
      const cells = [...this.table.querySelectorAll('thead th')];
      let height = 0;
      [...this.track.children].forEach((item, index) => {
        const cell = cells[index].getBoundingClientRect();
        item.style.width = `${cell.width}px`;
        item.style.left = `${cell.left - this.table.getBoundingClientRect().left}px`;
        height = Math.max(height, item.getBoundingClientRect().height);
      });
      this.track.style.height = `${height}px`;
      this.sticky.hidden = head.bottom > top || rect.bottom <= top + height || rect.top > innerHeight;
      this.sticky.style.left = `${rect.left}px`; this.sticky.style.width = `${rect.width}px`; this.sticky.style.top = `${top}px`;
      this.track.style.width = `${this.table.getBoundingClientRect().width}px`;
      this.track.style.transform = `translateX(${this.table.getBoundingClientRect().left - rect.left}px)`;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
})();
